module.exports = __webpack_public_path__ + "static/media/passbook.d3f976fc.svg";